import { create } from 'zustand';

const useRefreshStore = create((set) => ({
  refreshKeys: {},

  triggerRefresh: (pageName) =>
    set((state) => ({
      refreshKeys: {
        ...state.refreshKeys,
        [pageName]: (state.refreshKeys[pageName] || 0) + 1,
      },
    })),
}));

export default useRefreshStore;
